import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { BrowserRouter, HashRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import './app/config/interceptors/axiosInterceptors'
import i18n from './app/config/translation/i18n';
import store, { persistor } from './app/store/store';
import ArcModalContainer from 'app/components/arc/ArcModalContainer';
import { PersistGate } from 'redux-persist/integration/react';
import {HelmetProvider} from "react-helmet-async";
import { AuthProvider } from "react-oidc-context";
import { onSignInCallback, userManager } from "app/config/oidc";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <HashRouter>
    <AuthProvider userManager={userManager} onSigninCallback={onSignInCallback}>
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <HelmetProvider>
              <App />
            </HelmetProvider>
            <ArcModalContainer />
          </PersistGate>
        </Provider>
      </I18nextProvider>
    </AuthProvider>
  </HashRouter>
);